var app = angular.module('leonardo');

var WidgetRecurrence = function(TemplateService, $rootScope, $timeout) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/recurrence.html',
    priority: 1001,
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.templateService = TemplateService;
      scope.init = false;
      scope.yearly_repeat = false;
      scope.fixed_date_repeat = false;

      scope.isNull = isNull;

      scope.recurrence = {
        type: null,
        recurrence: {}
      };

      scope.fixDateTypes = [
        {id:'fixed_day', name: 'Date'},
        {id:'day_of_month', name: 'Day'},
        {id:'relative_day_of_month', name: 'The'}
      ];

      scope.weeklyOptions = TemplateService.RECURRENCE_WEEKLY_OPTIONS;

      scope.yearlyOptions = TemplateService.RECURRENCE_YEARLY_OPTIONS.map((op) => { return {id: op.substring(0, 3), name: op} });

      scope.intervalOptions = TemplateService.RECURRENCE_INTERVAL_OPTIONS.map(op => { return {id: op, name: op} });

      scope.ngModelCtrl.$render = function() {
        scope.recurrence = scope.ngModelCtrl.$modelValue;
        if (!scope.recurrence) {
          scope.recurrence = {
            type: TemplateService.RECURRENCE_WEEKLY,
            recurrence: {}
          };
          scope.recurrence.recurrence['monday'] = true;
          scope.recurrence.recurrence['tuesday'] = true;
          scope.recurrence.recurrence['wednesday'] = true;
          scope.recurrence.recurrence['thursday'] = true;
          scope.recurrence.recurrence['friday'] = true;
          scope.ngModelCtrl.$setViewValue(scope.recurrence);
        }
        else {
          if (!isNull(scope.recurrence.recurrence.yearly_conditions) &&
            !isNull(scope.recurrence.recurrence.yearly_conditions.repeat_every)) {
            scope.yearly_repeat = true;
          }
          if (!isNull(scope.recurrence.recurrence.fixed_date_conditions) &&
            (scope.recurrence.recurrence.fixed_date_conditions.type === "fixed_day") &&
            !isNull(scope.recurrence.recurrence.fixed_date_conditions.repeat_every)) {
            scope.fixed_date_repeat = true;
          }
        }
      };

      scope.getAllOptions = function(key) {
        switch (key) {
          case 'all-days':
            return TemplateService.RECURRENCE_WEEKLY_OPTIONS.map(d => d.name);
          case 'all-weeks':
            return TemplateService.RECURRENCE_MONTHLY_OPTIONS;
          case 'all-months':
            return TemplateService.RECURRENCE_YEARLY_OPTIONS;
        }
        return [];
      };

      scope.allOptionsEnabled = function(key) {
        var all = true;
        var options = scope.getAllOptions(key);
        angular.forEach(options, function(op) {
          if (!scope.recurrence.recurrence[op]) {
            all = false;
          }
        });
        return all;
      };

      scope.getAllOptionClasses = function(key) {
        if (scope.allOptionsEnabled(key)) {
          return ['active'];
        }
        return [];
      };

      scope.toggleAllOption = function(key) {
        var options = scope.getAllOptions(key);
        var value = scope.allOptionsEnabled(key) ? false : true;
        angular.forEach(options, function(key) {
          scope.recurrence.recurrence[key] = value;
        });
        scope.yearly_repeat = false;
        scope.repeatYearly();
      };

      scope.getEmptyRecurrence = function() {
        var recurrence = {};
        angular.forEach(TemplateService.RECURRENCE_WEEKLY_OPTIONS.map(d => d.name), function (key) {
          recurrence[key] = false;
        });
        angular.forEach(TemplateService.RECURRENCE_MONTHLY_OPTIONS, function (key) {
          recurrence[key] = false;
        });
        angular.forEach(TemplateService.RECURRENCE_YEARLY_OPTIONS, function (key) {
          recurrence[key] = false;
        });
        recurrence.date = null;
        recurrence.bump_to_next_day_if_closed = false;
        recurrence.yearly = false;
        return recurrence;
      };

      scope.repeatYearly = function() {
        if (scope.yearly_repeat) {
          if (isNull(scope.recurrence.recurrence.yearly_conditions)) {
            scope.recurrence.recurrence.yearly_conditions = {};
          }
        }
        else {
          scope.recurrence.recurrence.yearly_conditions = null;
        }
      };

      scope.setRecurrence = function(recurrence) {
        var result = {
          type: recurrence.type,
          recurrence:{}
        };
        if (!isNull(result.type)) {
          switch (result.type.toString()) {
            case TemplateService.RECURRENCE_FIXED_DATE:
              if (recurrence.recurrence.fixed_date_conditions) {
                result.recurrence.fixed_date_conditions = {
                  type: recurrence.recurrence.fixed_date_conditions.type
                };
                switch (result.recurrence.fixed_date_conditions.type) {
                  case 'fixed_day':
                    result.recurrence.fixed_date_conditions.date = recurrence.recurrence.fixed_date_conditions.date;
                    if (scope.fixed_date_repeat) {
                      result.recurrence.fixed_date_conditions.repeat_every = recurrence.recurrence.fixed_date_conditions.repeat_every;
                      result.recurrence.fixed_date_conditions.repeat_type = recurrence.recurrence.fixed_date_conditions.repeat_type;
                    }
                    break;
                  case 'day_of_month':
                    result.recurrence.fixed_date_conditions.day = recurrence.recurrence.fixed_date_conditions.day;
                    result.recurrence.fixed_date_conditions.every_x_months = recurrence.recurrence.fixed_date_conditions.every_x_months;
                    break;
                  case 'relative_day_of_month':
                    result.recurrence.fixed_date_conditions.weekday_position_in_month = recurrence.recurrence.fixed_date_conditions.weekday_position_in_month;
                    result.recurrence.fixed_date_conditions.weekday = recurrence.recurrence.fixed_date_conditions.weekday;
                    result.recurrence.fixed_date_conditions.every_x_months = recurrence.recurrence.fixed_date_conditions.every_x_months;
                    break;
                }
              }
              break;
            case TemplateService.RECURRENCE_WEEKLY:
              angular.forEach(TemplateService.RECURRENCE_WEEKLY_OPTIONS, function (day) {
                result.recurrence[day.name] = recurrence.recurrence[day.name];
              });
              break;
            case TemplateService.RECURRENCE_MONTHLY:
              angular.forEach(TemplateService.RECURRENCE_MONTHLY_OPTIONS, function (key) {
                result.recurrence[key] = recurrence.recurrence[key];
              });
              break;
            case TemplateService.RECURRENCE_YEARLY:
              result.recurrence.yearly_conditions = {};
              if (scope.yearly_repeat && recurrence.recurrence.yearly_conditions) {
                result.recurrence.yearly_conditions.repeat_every = recurrence.recurrence.yearly_conditions.repeat_every;
              }
              angular.forEach(TemplateService.RECURRENCE_YEARLY_OPTIONS, function (key) {
                result.recurrence[key] = recurrence.recurrence[key];
              });
              break;
          }
        }
        return result;
      };

      scope.ngModelCtrl.$validators.required = function(modelValue) {
        if (!scope.required) {
          return true;
        }
        var atleastOne = false;
        if (scope.recurrence && !isNull(scope.recurrence.type)) {
          switch (scope.recurrence.type.toString()) {
            case TemplateService.RECURRENCE_DAILY:
              return true;
            case TemplateService.RECURRENCE_FIXED_DATE:
              if (scope.recurrence.recurrence.fixed_date_conditions) {
                switch (scope.recurrence.recurrence.fixed_date_conditions.type) {
                  case 'fixed_day':
                    if (!scope.fixed_date_repeat) {
                      return !isNull(scope.recurrence.recurrence.fixed_date_conditions.date);
                    }
                    else {
                      return (!isNull(scope.recurrence.recurrence.fixed_date_conditions.date) &&
                        !isNull(scope.recurrence.recurrence.fixed_date_conditions.repeat_every) &&
                        !isNull(scope.recurrence.recurrence.fixed_date_conditions.repeat_type));
                    }
                  case 'day_of_month':
                    return (!isNull(scope.recurrence.recurrence.fixed_date_conditions.day) &&
                      !isNull(scope.recurrence.recurrence.fixed_date_conditions.every_x_months));
                  case 'relative_day_of_month':
                    return (!isNull(scope.recurrence.recurrence.fixed_date_conditions.weekday_position_in_month) &&
                      !isNull(scope.recurrence.recurrence.fixed_date_conditions.weekday) &&
                      !isNull(scope.recurrence.recurrence.fixed_date_conditions.every_x_months));
                  default:
                    return false;
                }
              }
              else {
                return false;
              }
            case TemplateService.RECURRENCE_WEEKLY:
              angular.forEach(TemplateService.RECURRENCE_WEEKLY_OPTIONS, function (day) {
                if (scope.recurrence.recurrence[day.name]) {
                  atleastOne = true;
                }
              });
              return atleastOne;
            case TemplateService.RECURRENCE_MONTHLY:
              angular.forEach(TemplateService.RECURRENCE_MONTHLY_OPTIONS, function (key) {
                if (scope.recurrence.recurrence[key]) {
                  atleastOne = true;
                }
              });
              return atleastOne;
            case TemplateService.RECURRENCE_YEARLY:
              if (scope.yearly_repeat) {
                return (!isNull(scope.recurrence.recurrence.yearly_conditions.repeat_every) &&
                  (scope.recurrence.recurrence.yearly_conditions.repeat_every > 0));
              }
              angular.forEach(TemplateService.RECURRENCE_YEARLY_OPTIONS, function (key) {
                if (scope.recurrence.recurrence[key]) {
                  atleastOne = true;
                }
              });
              return atleastOne;
          }
        }

        return false;
      };

      scope.$watch('recurrence', function(newValue, oldValue) {
        if (!angular.equals(newValue,oldValue)) {
          var result = scope.setRecurrence(newValue);
          scope.ngModelCtrl.$setViewValue(result);
          $rootScope.$broadcast('recurrence:updated', result);
          scope.ngModelCtrl.$validate();
        }
      }, true);

      scope.$watch('recurrence.type', function(newValue, oldValue) {
        if (!angular.equals(newValue,oldValue) || !scope.init) {
          if (newValue != TemplateService.RECURRENCE_FIXED_DATE) {
            scope.recurrence.recurrence.fixed_date_conditions = {};
          }
          if (newValue == TemplateService.RECURRENCE_YEARLY) {
            $timeout(function() {
              scope.repeatYearly();
            }, 10);
          }
          scope.init = true;
        }
      });

      scope.removeFilters = function () {
        $timeout(function() {
          if(!scope.fixed_date_repeat){
            scope.recurrence.recurrence.fixed_date_conditions.repeat_every = null;
            scope.recurrence.recurrence.fixed_date_conditions.repeat_type = null;
          }
          scope.ngModelCtrl.$validate();
        }, 10);
      };

    }
  };
};

app.directive('widgetRecurrence', ['TemplateService', '$rootScope', '$timeout', WidgetRecurrence]);
